import { ALL_PRODUCTS } from "constants/products";

export const mainSliders = Object.values(ALL_PRODUCTS).map(
  (product) => product
);
